"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticsService = void 0;
const api_1 = require("../api");
class DiagnosticsService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    getToken(params) {
        return this.fetch(`/${this.apiVersion}/diagnostics/tokens`, {
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
        });
    }
}
exports.DiagnosticsService = DiagnosticsService;
